<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <form @submit.prevent="validateSaveCustomerUser">
                    <div class="form-group">
                        <label for="nameInput">
                            First Name
                        </label>
                        <div class="text-danger" v-if="customerUser.firstName.hasError">
                            {{customerUser.firstName.errorMessage}}
                        </div>
                        <input type="text" class="form-control" id="nameInput" v-model="customerUser.firstName.value">
                    </div>
                    <div class="form-group">
                        <label for="lastNameInput">
                            Last Name
                        </label>
                        <div class="text-danger" v-if="customerUser.lastName.hasError">
                            {{customerUser.lastName.errorMessage}}
                        </div>
                        <input type="text" class="form-control" id="lastNameInput" v-model="customerUser.lastName.value">
                    </div>
                    <div class="form-group">
                        <label for="emailAddressInput">
                            Email Address
                        </label>
                        <div class="text-danger" v-if="customerUser.emailAddress.hasError">
                            {{customerUser.emailAddress.errorMessage}}
                        </div>
                        <input type="email" class="form-control" id="emailAddressInput" v-model="customerUser.emailAddress.value">
                    </div>
    
                    <div class="form-group">
                        <label for="roleSelect">
                            Role
                        </label>
                        <div class="text-danger" v-if="customerUser.roleId.hasError">
                            {{customerUser.roleId.errorMessage}}
                        </div>
                        <bootstrap-select :selectOptions="customerUserRoles" :selectedOption="customerUser.roleId.value" :elementId="'roleSelect'"
                                            :returnSelectedOptionText="true"
                                            @changeSelect="onRoleSelect"></bootstrap-select>
                    </div>
                    <div class="form-group">
                        <label>Can View All Orders?</label>
                        <div class="text-danger" v-if="customerUser.canViewAllOrders.hasError">
                            {{customerUser.canViewAllOrders.errorMessage}}
                        </div>
                        <div class="row sortByRadioButtons">
                            <div class="radio ascendingRadioButton">
                                <input class="" type="radio" name="yesOrNoRadioButton" id="yesRadioButton" :value="true" 
                                        v-model="customerUser.canViewAllOrders.value">
                                <label class="" for="yesRadioButton">
                                    Yes
                                </label>
                            </div>
                            <div class="radio">
                                <input class="" type="radio" name="yesOrNoRadioButton" id="noRadioButton" :value="false" 
                                        v-model="customerUser.canViewAllOrders.value">
                                <label class="" for="noRadioButton">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group form-check" v-if="isUpdate">
                        <input class="form-check-input" type="checkbox" value="" id="resetPasswordCheckbox" v-model="resetPassword">
                        <label class="form-check-label" for="resetPasswordCheckbox">
                            Reset Password
                        </label>
                    </div>
                    <div class="text-danger" v-if="customerUser.password.hasError">
                        {{customerUser.password.errorMessage}}
                    </div>
                    <password-generator @passwordGenerated="onPasswordGenerated" v-if="!isUpdate || resetPassword"></password-generator>

                    <button class="btn btn-primary mr-2" :disabled="loading">Save</button>
                    <button class="btn btn-secondary" @click.prevent="onBackClick" :disabled="loading">Back</button>
                    
                </form>
            </div>
        </div>
    </div>

    <error-modal :modalHeading="errorModal.modalHeading" 
                :elementId="errorModal.elementId" 
                :modalMessage="errorModal.modalMessage" 
                :showModal="errorModal.showModal"
                @okClicked="errorModalOkClicked"></error-modal>
    <success-modal
            :modalHeading="successModal.modalHeading" 
            :elementId="successModal.elementId" 
            :modalMessage="successModal.modalMessage" 
            :showModal="successModal.showModal"
            @okClicked="successModalOkClicked">
    </success-modal>
</div>
